import { useContext, useEffect, useRef } from "react";

import { CurrentPlatformContext } from "./CurrentPlatformContext";

export const useCurrentPlatformContext = () => {
  return useContext(CurrentPlatformContext);
};

export const useCurrentPlatform = () => {
  const { platform } = useCurrentPlatformContext();

  if (!platform) {
    throw new Error("Current platform not found");
  }

  return platform;
};

export const useSwitchPlatform = () => {
  const { switchPlatform } = useCurrentPlatformContext();
  return switchPlatform;
};

export const useAccessiblePlatformsCount = () => {
  const { accessiblePlatformsCount } = useCurrentPlatformContext();
  return accessiblePlatformsCount;
};

export const useAvailablePlatformsCount = () => {
  const { availablePlatformsCount } = useCurrentPlatformContext();
  return availablePlatformsCount;
};

export const useOnCurrentPlatformChange = (callback: () => void) => {
  const platform = useCurrentPlatform();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      return;
    }
    callbackRef.current();
  }, [platform.id]);
};
